// import { Grid } from '@chakra-ui/core'
// import { SomePlugin } from './plugins/SomePlugin'
import { IOnOrderCreatedParams, StorefrontPlugins } from '@engyalo/storefront-types'
import { IProduct } from '@engyalo/storefront-types/lib/plugins/model'

function parseJSON<T extends Object>(object: T | string) {
  let parsed = null
  try {
    parsed = typeof object === 'string' ? JSON.parse(object) : object
  } catch (error) {
    parsed = null
  }

  return parsed
}

export const plugins = {
  Storefront: {
    props: {
      showCategoriesView: true,
      hidePrices: true,
    },
  },
} as StorefrontPlugins